import react from "react";
import React from "react";
import { Link } from "react-router-dom";

function SustainabilityInQualityAssurance() {
  return (
    <div className="bg-light">
      <div class="wrapper2">
        <h2 class="heading2">Sustainability in Quality Assurance</h2>
      </div>
      <section class="py-0">
        <div class="container py-0">
          <div class="row g-3">
            <div class="col-lg-4 col-12">
              <p class="card-text text-muted py-3 px-2">
                Sustainability shapes every aspect of our operations. Our
                Quality Assurance Hubs leverage solar power and energy-efficient
                practices to minimize environmental impact while maintaining
                excellence. We’re committed to greener processes that protect
                the planet without compromising on quality.
              </p>

              <div class="underline2  my-3 mx-1"></div>

              <h6 class="card-title fw-bold my-2 mx-1">
                Our Sustainable Practices
              </h6>
            </div>
          </div>
        </div>
      </section>
      <div class="bg-light">
        <div class="container p-3">
          <div class="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-2 g-3">

            <div class="product-item col">
              <div class="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img
                  src="img/Solar-Powered-Operations_.png"
                  alt=""
                  class="card-img-top"
                />
                <h6
                  class="fw-normal"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    paddingTop: "10px",
                    color: "black",
                  }}
                >
                  Solar-Powered
                  <br /> Operations
                </h6>
              </div>
            </div>


            <div class="product-item col">
              <div class="card h-100 rounded-4 overflow-hidden osahan-card-list">
                <img
                  src="img/Energy-Efficient-Testing-Processes_.png"
                  alt=""
                  class="card-img-top"
                />
                <h6
                  class="fw-normal"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    paddingTop: "10px",
                    color: "black",
                  }}
                >
                  Energy-Efficient
                  <br /> Testing Processes
                </h6>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* <div class="container p-3">
        <div class="underline2"></div>
      </div>
      <div class="bg-light">
        <div class="container p-3">
          <h6 class="card-title fw-bold my-2">Quality Check Insights</h6>

        
          <div class="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">
            <a href="/technology-driven-quality-tests">
              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img
                    src="img/Technology-Driven Quality Tests_.png"
                    alt=""
                    class="card-img-top"
                  />

                 
                  <div
                    class="position-absolute top-0 start-0 w-100 h-100"
                    style={{ background: "rgba(0, 0, 0, 0.4)" }}
                  ></div>

                  <div
                    class="position-absolute text-overlay-f text-white p-3"
                    style={{ zIndex: 1, top: "25%" }}
                  >
                    <h6 class="fw-normal" style={{ fontSize: "12px" }}>
                      Technology-Driven Quality Tests
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/sustainability">
              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img
                    src="img/Sustainability-in-Quality-Assurance_.png"
                    alt=""
                    class="card-img-top"
                  />

              
                  <div
                    class="position-absolute top-0 start-0 w-100 h-100"
                    style={{ background: "rgba(0, 0, 0, 0.4)" }}
                  ></div>

                
                  <div
                    class="position-absolute text-overlay-f text-white p-3"
                    style={{ zIndex: 1, top: "25%" }}
                  >
                    <h6 class="fw-normal" style={{ fontSize: "12px" }}>
                      Sustainability in Quality Assurance
                      <br />
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="/cloud-connectivity-quality">
              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img
                    src="img/Cloud-Connectivity_.png"
                    alt=""
                    class="card-img-top"
                  />

                 
                  <div
                    class="position-absolute top-0 start-0 w-100 h-100"
                    style={{ background: "rgba(0, 0, 0, 0.4)" }}
                  ></div>

                
                  <div
                    class="position-absolute text-overlay-f text-white p-3"
                    style={{ zIndex: 1 }}
                  >
                    <h6 class="fw-normal" style={{ fontSize: "12px" }}>
                      Cloud Connectivity
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}
      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/technology-driven-quality-tests-2"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/cloud-connectivity-quality"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
      {/* <Index /> */}
    </div>
  );
}

export default SustainabilityInQualityAssurance;
